var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"24px"}},[_c('CommonExpansionPanel',{scopedSlots:_vm._u([{key:"title-panel",fn:function(){return [_vm._v("Documentos")]},proxy:true}])},[_c('v-expansion-panel-content',[(_vm.switch_data == 1)?_c('TablaDocumentosAlianza',{attrs:{"alianzaData":_vm.alianzaData}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }